import EmptySec from "./EmptySec";
import TrustedClients from "./TrustedClients";

export default function Segment2(){
    return(
    <div className="seg2">
        <TrustedClients/>
    </div>
    )
}